export const GEAR_CATEGORIES = [
  {
    id: "consoles",
    label: "Consolas / PCs",
    icon: "🎮",
    items: ["PS5", "PS4", "Xbox Series X", "Xbox One", "PC Gaming"],
  },
  {
    id: "handheld",
    label: "Handhelds",
    icon: "📱",
    items: ["Nintendo Switch", "Nintendo Switch Lite", "Steam Deck", "ROG Ally", "ROG Ally X", "PS Vita"],
  },
  {
    id: "retro",
    label: "Retro",
    icon: "👾",
    items: ["PlayStation 1", "PlayStation 2", "Super Nintendo", "Nintendo 64", "Sega Mega Drive", "Atari", "Neo Geo", "TV CRT (retro)"],
  },
  {
    id: "monitors",
    label: "Monitores / TVs",
    icon: "🖥️",
    items: ['Monitor 24"', 'Monitor 27"', 'TV 32"', 'TV 43"', 'TV 55"+', "Monitor ultrawide"],
  },
  {
    id: "games",
    label: "Juegos",
    icon: "⚔️",
    items: ["Street Fighter 6", "Tekken 8", "2XKO", "Dragon Ball FighterZ", "Guilty Gear Strive", "King of Fighters XV", "Soul Calibur VI", "Marvel vs Capcom"],
  },
  {
    id: "cables",
    label: "Cables / Accesorios",
    icon: "🔌",
    items: ["HDMI", "Cable de corriente extra", "Regleta", "Adaptador HDMI-DisplayPort", "USB Hub", "Brook adapter", "Ethernet cable"],
  },
];
